import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import brandingService from "../../services/brandingService";

const useBrandingForSite = (siteExternalId?: string | null) =>
    useQuery(
        [queryKeys.brandingForSite, siteExternalId],
        () => brandingService.fetchBrandingForSite(siteExternalId),
        { enabled: !!siteExternalId }
    );

export default useBrandingForSite;
